var Calendar = function Calendar(_ref) {
  var className = _ref.className,
    date = _ref.date;
  return /*#__PURE__*/React.createElement("div", {
    className: 'calendar ' + className
  }, /*#__PURE__*/React.createElement("div", {
    className: "calendar__month"
  }, moment(date).format('MMMM')), /*#__PURE__*/React.createElement("div", {
    className: "calendar__day"
  }, moment(date).format('D')), /*#__PURE__*/React.createElement("div", {
    className: "calendar__year"
  }, moment(date).format('YYYY')));
};
export default Calendar;